import Vue from 'vue'
import Router from 'vue-router'

/**
 * 画面レイアウト
 */
import header from '@/components/TheHeader'
import footer from '@/components/TheFooter'

/**
 * システム画面
 */
import PageNotFound from '@/components/PageNotFound'

/**
 * 一般画面
 */
import Home from '@/components/Home'
import PartnerAppSelection from '@/components/PartnerAppSelection'
import EnduserAppSelection from '@/components/EnduserAppSelection'
import Copyright from '@/components/Copyright'

/**
 * 各種申請書
 */
import BuyLicenseAndSupport from '@/components/apps/BuyLicenseAndSupport'
import ServiceRequest from '@/components/apps/ServiceRequest'
import LicenseAddition from '@/components/apps/LicenseAddition'
import LicenseSubtraction from '@/components/apps/LicenseSubtraction'
import ChangeCustomerInfo from '@/components/apps/ChangeCustomerInfo'
import Saved from '@/components/apps/Saved'

Vue.use(Router)
const config = require('../../config')
const subdirectory = process.env.NODE_ENV === 'production'
  ? config.build.assetsPublicPath
  : config.dev.assetsPublicPath

const router = new Router({
  base: subdirectory,
  // 画面遷移時はスクロールTOPに戻る
  scrollBehavior (to, from, savedPosition) {
    // scrollをbodyにつけたので、return値が利かなくなっているので、直接scrollToを書いておく
    // IEはelement.scrollTo()非対応
    document.body.scrollTop = 0
    document.body.scrollLeft = 0
    return { x: 0, y: 0 }
  },
  routes: [
    {
      path: '/',
      name: 'home',
      components: {
        header,
        footer,
        content: Home
      }
    },
    {
      path: '/partner',
      name: 'partner',
      components: {
        header,
        footer,
        content: PartnerAppSelection
      }
    },
    {
      path: '/enduser',
      name: 'enduser',
      components: {
        header,
        footer,
        content: EnduserAppSelection
      }
    },
    {
      path: '/copyright',
      name: 'copyright',
      components: {
        header,
        footer,
        content: Copyright
      }
    },
    {
      path: '/apps/buy-license-and-support',
      name: 'BuyLicenseAndSupport',
      components: {
        header,
        footer,
        content: BuyLicenseAndSupport
      }
    },
    {
      path: '/apps/service-request',
      name: 'ServiceRequest',
      components: {
        header,
        footer,
        content: ServiceRequest
      }
    },
    {
      path: '/apps/license-addition',
      name: 'LicenseAddition',
      components: {
        header,
        footer,
        content: LicenseAddition
      }
    },
    {
      path: '/apps/license-subtraction',
      name: 'LicenseSubtraction',
      components: {
        header,
        footer,
        content: LicenseSubtraction
      }
    },
    {
      path: '/apps/change-customer-info',
      name: 'ChangeCustomerInfo',
      meta: {
        title: 'お客様情報変更申請'
      },
      components: {
        header,
        footer,
        content: ChangeCustomerInfo
      }
    },
    {
      path: '/apps/saved',
      name: 'Saved',
      meta: {
        confirmLeave: true,
        confirmLeaveMessage: 'PDFがまだダウンロードされていません。画面を移動してもよろしいですか？'
      },
      components: {
        header,
        footer,
        content: Saved
      }
    },
    // 404
    {
      path: '*',
      meta: {
        needAuth: false
      },
      components: {
        header,
        footer,
        content: PageNotFound
      }
    }
  ]
})

router.beforeEach(function (to, from, next) {
  // フラグ付きのページはページを離れる前に確認する
  let confirmed = from.meta.confirmLeave
    ? confirm(from.meta.confirmLeaveMessage || '画面を移動します。よろしいですか？')
    : true
  next(confirmed)
})

export default router



// WEBPACK FOOTER //
// ./src/router/index.js